<template>
	<b-card class="w-100 no-border">
		<b-card-body>
			<div class="text-center my-3">
				<img src="../../../assets/img/new_avatar_alfred_transp.png" />
			</div>
			<div class="p-3" v-if="!credentialIsValidated">
				<b-alert :show="show_alert" :variant="alert_variant">
					<span v-html="processMessage"></span>
				</b-alert>
				<b-form @submit.prevent="onSubmit">
					<b-form-group label-for="phone" label="Celular ou E-mail">
						<b-form-input
							type="text"
							id="phone"
							class="mb-0"
							v-model="phone"
							placeholder="Digite o número do seu celular, ou E-mail registrado no sistema"
							debounce="500"
							:state="validate_phone"
						></b-form-input>
						<b-form-invalid-feedback id="phone-feedback">
							Informe um número de celular ou um e-mail válido.
						</b-form-invalid-feedback>
					</b-form-group>

					<div class="mt-3">
						<b-button block variant="primary" type="submit" class="btn-custom">
							<b-spinner small v-if="is_loading" class="text-white"></b-spinner>
							{{ !is_loading ? 'Gerar chave de acesso ' : 'Processando' }}
						</b-button>
					</div>
				</b-form>
			</div>
			<div v-if="credentialIsValidated">
				<b-row class="d-flex justify-content-center mb-2">
					<h5>Insira chave de acesso</h5>
				</b-row>
				<b-row style="gap: 10px; margin-left: -40px" class="d-flex justify-content-center">
					<b-col cols="1">
						<input
							v-model="char1"
							type="text"
							style="max-width: 38px; min-width: 38px"
							maxlength="1"
							autocomplete="one-time-code"
							@input="handleInput(0)"
							pattern="[0-9]*"
							class="char-input"
							ref="char1"
						/>
					</b-col>
					<b-col cols="1">
						<input
							style="max-width: 38px; min-width: 38px"
							type="text"
							class="char-input"
							maxlength="1"
							autocomplete="one-time-code"
							@input="handleInput(1)"
							v-model="char2"
							pattern="[0-9]*"
							ref="char2"
						/>
					</b-col>
					<b-col cols="1">
						<input
							style="max-width: 38px; min-width: 38px"
							type="text"
							class="char-input"
							maxlength="1"
							autocomplete="one-time-code"
							@input="handleInput(2)"
							v-model="char3"
							pattern="[0-9]*"
							ref="char3"
						/>
					</b-col>
					<b-col cols="1">
						<input
							style="max-width: 38px; min-width: 38px"
							type="text"
							class="char-input"
							maxlength="1"
							autocomplete="one-time-code"
							@input="handleInput(3)"
							v-model="char4"
							pattern="[0-9]*"
							ref="char4"
						/>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<div :class="countdownTextClass" class="mt-4">
							<vue-countdown
								:time="time"
								:transform="transformCountdown"
								tag="span"
								ref="countdown"
								:auto-start="true"
								@end="handleCountdownEnd"
							>
								<template slot-scope="props">
									<ul class="vue-countdown">
										<li class="text-center">
											<p class="digit" style="font-size: 10px">{{ props.minutes }}</p>
											<!-- <p class="text">m</p> -->
										</li>
										<li class="text-center">
											<p class="digit" style="font-size: 10px">:</p>
											<!-- <p class="digit">m</p> -->
										</li>
										<li class="text-center">
											<p class="digit" style="font-size: 10px">{{ props.seconds }}</p>
											<!-- <p class="text">s</p> -->
										</li>
									</ul>
								</template>
							</vue-countdown>
						</div>
					</b-col>
				</b-row>
				<b-row v-if="1 === 0" class="mt-2">
					<b-col class="d-flex justify-content-center">
						<b-button
							variant="primary"
							@click="validateAccessKey"
							style="background-color: #fb3e3e; border: 1px solid #fb3e3e; width: 194px"
						>
							Login
						</b-button>
					</b-col>
				</b-row>
				<b-row>
					<b-col class="mt-1 d-flex justify-content-center">
						<b-link @click="() => (credentialIsValidated = false)">
							<span style="font-size: 10px; color: rgba(0, 0, 0, 0.4)">
								Enviar nova chave de acesso
							</span>
						</b-link>
					</b-col>
				</b-row>
			</div>
		</b-card-body>
	</b-card>
</template>

<script>
	import ApiService from '../../../common/api.service'
	import jwtService from '../../../common/jwt.service'
	import VueCountdown from '@chenfengyuan/vue-countdown'

	export default {
		name: 'LoginSMS',
		components: {
			VueCountdown
		},
		data() {
			return {
				show_alert: false,
				alert_variant: null,
				processMessage: null,
				is_loading: false,
				validate_phone: null,
				validate_email: null,
				phone: null,
				email: null,
				accessKey: null,
				credentialIsValidated: true,
				char1: null,
				char2: null,
				char3: null,
				char4: null,
				countdownTextClass: null,
				time: null,
				nextPage: '/app/dashboard'
			}
		},
		watch: {
			phone: function () {
				this.validateEmail()
				this.validatePhone()
			},
			char1: function () {
				if (this.char1 !== '') {
					this.$refs.char2.focus()
				}
				if (this.char1 === '') {
					this.$refs.char1.focus()
				}
			},
			char2: function () {
				if (this.char2 !== '') {
					this.$refs.char3.focus()
				}
				if (this.char2 === '') {
					this.$refs.char1.focus()
				}
			},
			char3: function () {
				if (this.char3 !== '') {
					this.$refs.char4.focus()
				}
				if (this.char3 === '') {
					this.$refs.char2.focus()
				}
			},
			char4: function () {
				if (this.char4 !== '') {
					this.accessKey = this.char1 + this.char2 + this.char3 + this.char4
					this.validateAccessKey()
				}
				if (this.char4 === '') {
					this.$refs.char3.focus()
				}
			}
		},
		mounted() {
			this.$refs.char1.focus()

			if ('OTPCredential' in window) {
				this.startOTPListener()
			}
		},
		methods: {
			validateEmail: function () {
				if (this.phone) {
					if (this.regexEmail(this.phone)) {
						this.validate_email = true
					} else {
						this.validate_email = false
					}
				} else {
					this.validate_email = false
				}
			},

			validatePhone: function () {
				if (!this.validate_email) {
					if (this.phone) {
						if (this.phone.length == 11) {
							this.validate_phone = true
						} else {
							this.validate_phone = false
						}
					} else {
						this.validate_phone = false
					}
				} else {
					if (this.phone.length == 11) {
						this.validate_phone = false
					} else {
						this.validate_phone = true
					}
				}
			},
			onSubmit() {
				if (!this.phone && !this.email) {
					this.validate_phone = false
				}

				if (this.validate_phone && !this.is_loading) {
					this.is_loading = true

					ApiService.post('generateAccessKey', {
						phone: this.phone
					})
						.then((response) => {
							if (response.data.status === 'success') {
								if (response.data.message === 'Credenciais válidas') {
									this.credentialIsValidated = true
									this.time = response.data.time * 1000
								} else {
								}
							} else {
							}
						})
						.finally(() => {
							this.is_loading = false
						})
						.catch((error) => {
							this.show_error = true
						})
				}
			},
			validateAccessKey() {
				ApiService.post('validateAccessKey', {
					accessKey: this.accessKey,
					phone: this.phone
				}).then((response) => {
					if (response.data.status == 'success') {
						this.show_alert = true
						this.alert_variant = 'success'
						this.processMessage = response.data.message
						this.$store.dispatch('login', response)

						if (this.$cookies.isKey('alfred_navigation_page')) {
							this.nextPage = this.$cookies.get('alfred_navigation_page').page
						}

						if (
							response.data?.roles[0].name === 'coordenador' ||
							response.data?.roles[0].name === 'professor'
						) {
							jwtService.setEscolasUser(response.data?.escolas)
							window.location.href = this.schoolSelectionPage
						} else {
							window.location.href = this.nextPage
						}
					} else {
						this.show_alert = true
						this.alert_variant = 'danger'
						this.processMessage = response.data.message
					}
				})
			},
			regexEmail: function (email) {
				const re =
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
				return re.test(email)
			},

			transformCountdown(props) {
				Object.entries(props).forEach(([key, value]) => {
					const digits = value < 10 ? `0${value}` : value
					props[key] = `${digits}`
				})
				return props
			},
			handleCountdownEnd: function (data) {
				this.credentialIsValidated = false
				this.char1 = null
				this.char2 = null
				this.char3 = null
				this.char4 = null
				this.accessKey = null
				this.time = null
			},

			async startOTPListener() {
				try {
					const content = await navigator.credentials.get({
						otp: { transport: ['sms'] },
						signal: new AbortController().signal
					})
					if (content && content.code) {
						this.fillCode(content.code)
					}
				} catch (err) {
					console.error('Erro ao obter código OTP:', err)
				}
			},
			fillCode(code) {
				this.code = code.split('')
				for (let i = 0; i < code.length; i++) {
					this.$refs[`codeInput${i}`].value = code[i]
				}
				this.verifyCode(code)
			},
			handleInput(index) {
				return (event) => {
					const nextIndex = index + 1
					if (nextIndex < 4) {
						this.$refs[`codeInput${nextIndex}`].focus()
					}
					const code = this.code.join('')
					if (code.length === 4) {
						this.verifyCode(code)
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700|Rubik:300,400,500');
	@import './assets/css/pe-icon-7-stroke.css';
	@import './assets/css/materialdesignicons.min.css';
	@import './assets/css/style.css';
	@import './assets/css/colors/red.css';
	.no-border {
		border: none !important;
	}
	input[type='number']::-webkit-outer-spin-button,
	input[type='number']::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type='number'] {
		-moz-appearance: textfield;
	}
	.char-input {
		text-align: center;
		box-shadow: 0 2px 1px rgba(62, 37, 82, 0.3); /* Adiciona sombra */
		// transition: box-shadow 0.3s ease; /* Suaviza a transição da sombra */
		border: 1px solid rgba(62, 37, 82, 0.5);
		height: 40px;
		border-radius: 4px;
	}

	.vue-countdown {
		display: flex !important;
		justify-content: center;
		text-align: left;
		display: inline-flex;
		list-style: none;
		padding-inline-start: 0px;
		margin-bottom: 0px;
	}

	.vue-countdown .digit {
		font-size: 22px;
		font-weight: 600;
		line-height: 1.4;
		margin-bottom: 0;
	}

	.vue-countdown .text {
		text-transform: uppercase;
		text-align: center;
		margin-bottom: 0;
		font-size: 10px;
	}
</style>
